module.exports = __webpack_public_path__ + "img/67ABITO-ANTIBE-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE2.bad2385d.jpg";